import {SellerError} from './SellerError.js'

export class GetDraftInstantOfferFromAPISellerError extends SellerError {}
